import styled, { css } from 'styled-components';

import { colors } from 'theme';

const styles = css`
  position: relative;
  background: ${colors.lightContentGrey};
  user-select: none;

  --video-thumbnail-play-background: rgba(0, 0, 0, 0.3);
  --video-thumbnail-play-color: ${colors.white};

  &:hover {
    --video-thumbnail-play-background: ${colors.white};
    --video-thumbnail-play-color: ${colors.brandBlue};
  }

  > * {
    pointer-events: none;
  }
`;

export const VideoThumbnailDivContainer = styled.div`
  ${styles};
`;

export const VideoThumbnailButtonContainer = styled.button`
  ${styles};
  cursor: pointer;

  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
`;
